import Utils from "./../../services/Utils.js";
import {getPost} from '../../js/api/postShow.js'
let PostShow = {
  render: async () => {
    let request = Utils.parseRequestURL();
    let post = await getPost(request.id);

    return /*html*/ `
            <section class="section">
                <h1> Post Id : ${post.id}</h1>
                <p> Post Title : ${post.title} </p>
                <p> Post Content : ${post.content} </p>
                <p> Post Author : ${post.name} </p>
            </section>
        `;
  },
  after_render: async () => {},
};

export default PostShow;
